import { getDependentPaths } from 'app/modules/fintracStr/formUtils';
import {
  FintracFormFieldConditional,
  FintracFormSingleField,
} from 'app/modules/fintracStr/models';
import { isFieldBlank } from 'app/modules/fintracStr/renderConditions';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

export const fintracStrTelephoneNumberFields = (
  basePath: (sectionIndex: number, fieldSectionIndex?: number[]) => string,
  hideIfTrue?: FintracFormFieldConditional,
): FintracFormSingleField[] => [
  [
    {
      type: U21FormFieldTypes.TEXT,
      name: 'telephoneNumber',
      label: 'Telephone number',
      mustExistInPayload: false,
      mustHaveValueIfExist: false,
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          hideIfTrue ? [hideIfTrue] : undefined,
          undefined,
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue,
    },
    {
      type: U21FormFieldTypes.TEXT,
      name: 'extensionNumber',
      label: 'Extension number',
      mustExistInPayload: false,
      mustHaveValueIfExist: false,
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          hideIfTrue ? [hideIfTrue] : undefined,
          [`${basePath(sectionIndex, fieldSectionIndex)}.telephoneNumber`],
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue: {
        ...hideIfTrue,
        or: [
          ...(hideIfTrue?.or || []),
          {
            path: (sectionIndex, fieldSectionIndex) =>
              `${basePath(sectionIndex, fieldSectionIndex)}.telephoneNumber`,
            conditions: (value) => isFieldBlank(value),
          },
        ],
      },
    },
  ],
];
